import { render, staticRenderFns } from "./Hydrophilic.vue?vue&type=template&id=bc3a2d2a&scoped=true"
import script from "./Hydrophilic.vue?vue&type=script&lang=js"
export * from "./Hydrophilic.vue?vue&type=script&lang=js"
import style0 from "./Hydrophilic.vue?vue&type=style&index=0&id=bc3a2d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3a2d2a",
  null
  
)

export default component.exports